import { useEffect, useRef } from "react";

export const useClickOutSide = ({ close = () => {} }) => {
  const inputRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef?.current && !inputRef?.current.contains(event?.target))
        close();
    };
    document.addEventListener("click", handleClickOutside);
  }, [inputRef]);

  return { inputRef };
};
